// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"962":"15202a71","990":"60d5d904"}[chunkId] + ".chunk.css";
};